import React from 'react';
import { Grid, Skeleton } from '@mui/material';

const PaymentReceiptSkeleton = () => {
    return (
        <div
            style={{
                background: 'none',
                border: 'none !important',
                position: 'relative',
                width: '100%',
                minWidth: '400px',
                margin: 'auto',
                backgroundImage: `url(/images/PaymentReceipt.png)`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% 100%',
                backgroundPosition: 'top center',
                height: '370px',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
                overflow: 'hidden',
            }}
        >
            <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} textAlign="center" className="yekanBakhFaNum primaryColorLight-900 !mt-14">
                    <Skeleton variant="text" width={120} height={30} sx={{ margin: '0 auto' }} />
                    <Skeleton variant="rectangular" width={100} height={30} sx={{ margin: '16px auto' }} />
                </Grid>

                <Grid item xs={12}>
                    <hr className="indented-hr" />
                </Grid>

                <Grid container item xs={12} className="yekanBakhFaNum primaryColorLight-900 !mx-6" textAlign="center">
                    <Grid container xs={12} className="mt-2">
                        {[...Array(3)].map((_, index) => (
                            <React.Fragment key={index}>
                                <Grid item xs={6} textAlign="right" className="!mt-4">
                                    <Skeleton variant="text" width="80%" />
                                </Grid>
                                <Grid item xs={6} textAlign="left" className="!mt-4">
                                    <Skeleton variant="text" width="80%" />
                                </Grid>
                            </React.Fragment>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default PaymentReceiptSkeleton;
